import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Iconify from '../Iconify';
import { useMemo } from 'react';
import '../../css/machines/machineCout.css';

const MachineCout = ({ expencePercentOfPrice }) => {

    const { t } = useTranslation();

    const statusColor = useMemo(() => {
        if (!expencePercentOfPrice && expencePercentOfPrice !== 0) return 'black';
        if (expencePercentOfPrice < 50) return '#309129';
        if (expencePercentOfPrice < 90) return '#F2B310';
        if (expencePercentOfPrice > 90 || expencePercentOfPrice === 90) return '#F12525';
        return 'black';
    }, [expencePercentOfPrice]);

    const statusIcon = useMemo(() => {
        if (!expencePercentOfPrice && expencePercentOfPrice !== 0) return 'fluent-mdl2:unknown';
        if (expencePercentOfPrice < 50) return 'material-symbols-light:check';
        if (expencePercentOfPrice < 90) return 'material-symbols:warning-outline';
        if (expencePercentOfPrice > 90 || expencePercentOfPrice === 90) return 'ic:round-close';
        return 'fluent-mdl2:unknown';
    }, [expencePercentOfPrice]);

    const statusLabel = useMemo(() => {
        return expencePercentOfPrice || expencePercentOfPrice === 0 ? `${expencePercentOfPrice} %` : 'Unknown';
    }, [expencePercentOfPrice]);

    return (
        <Box className='machines_cout_Box' sx={{ color: statusColor, borderColor: statusColor }}>
            <Iconify icon={statusIcon} className='machines_cout_icon' />
            <Typography className='machines_cout'>{t(statusLabel)}</Typography>
        </Box>
    );
};

export default MachineCout;